var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('ContactEntryBar',{attrs:{"on-contact-list-changed":_vm.onContactListChanged}}),_c('Sendbar',{attrs:{"on-send":_vm.sendMessage,"loading":_vm.sending}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }